module.exports = __webpack_public_path__ + "img/sponsorB17.a0245e4a.png";